import styled from 'styled-components';
import { colors, font, radius, shadow } from '../../../styles/theme/tokens';

export const Picker = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 1120px;
  margin-bottom: 20px;
  padding: 16px;
  font-family: ${font.text};
  background: ${colors.surface};
  border: 1px solid ${colors.line};
  border-radius: ${radius.lg};
  box-shadow: ${shadow.card};
`;

export const Search = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 42px;
  padding: 0 14px;
  border: 1px solid ${colors.line};
  border-radius: ${radius.md};
  color: ${colors.muted};
  background: ${colors.bg};

  input {
    flex: 1;
    min-width: 0;
    border: none;
    outline: none;
    font-family: ${font.text};
    font-size: 14px;
    color: ${colors.ink};
    background: transparent;
  }
`;

export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 180px;
  overflow-y: auto;
`;

export const Chip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 38px;
  padding: 6px 14px;
  border: 1px solid ${({ $active }) => ($active ? colors.brand : colors.line)};
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 700;
  color: ${({ $active }) => ($active ? '#FFFFFF' : colors.ink)};
  background: ${({ $active }) => ($active ? colors.brand : colors.surface)};
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;

  span {
    font-size: 12px;
    font-weight: 600;
    color: ${({ $active }) => ($active ? 'rgba(255,255,255,0.8)' : colors.muted)};
  }

  &:hover {
    border-color: ${colors.brand};
  }
`;

export const Empty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  max-width: 1120px;
  padding: 40px 20px;
  font-family: ${font.text};
  text-align: center;
  color: ${colors.muted};
  border: 1.5px dashed ${colors.line};
  border-radius: ${radius.lg};

  svg {
    color: ${colors.brand};
  }

  b {
    font-size: 16px;
    font-weight: 800;
    color: ${colors.ink};
  }

  span {
    font-size: 14px;
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: 1120px;
  padding: 0;
  list-style: none;
`;

export const HomeworkSection = styled.div`
  margin-top: -6px;
  padding: 18px;
  font-family: ${font.text};
  background: ${colors.surface};
  border: 1px solid ${colors.line};
  border-top: none;
  border-radius: 0 0 ${radius.lg} ${radius.lg};
`;

export const HomeworkText = styled.pre`
  margin: 0;
  padding: 14px 16px;
  font-family: ${font.text};
  font-size: 15px;
  line-height: 1.55;
  color: ${colors.ink};
  white-space: pre-wrap;
  word-wrap: break-word;
  background: ${colors.bg};
  border-radius: ${radius.md};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 14px;
`;

export const Button = styled.button`
  min-height: 42px;
  padding: 0 20px;
  border: none;
  border-radius: ${radius.md};
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 800;
  color: #FFFFFF;
  background: ${colors.success};
  box-shadow: ${shadow.button('#128A5A')};
  cursor: pointer;

  &:active {
    transform: translateY(2px);
    box-shadow: none;
  }
`;

export const RejectButton = styled(Button)`
  color: ${colors.ink};
  background: ${colors.bg};
  border: 1px solid ${colors.line};
  box-shadow: none;
`;

// 🆕 — превью изображений в сетке
export const ImagesGrid = styled.div`
  margin-top: 15px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
`;

export const ImagePreview = styled.img`
  width: 100%;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

// 🌙 Затемнённый фон с анимацией появления
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.25s ease;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

// 🖼️ Контейнер для картинки — аккуратно центрирован
export const ModalContent = styled.div`
  position: relative;
  max-width: 100vw;
  max-height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
  padding: 5px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.6);
  overflow: hidden;
`;

// 📸 Само изображение — без скроллов, адаптируется
export const ModalImage = styled.img`
  max-width: 100%;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 8px;
  display: block;
`;

// ❌ Кнопка закрытия — снаружи, но по центру верхнего угла
export const CloseButton = styled.button`
  position: absolute;
  top: 2px;
  right: 2px;
  background-color: #fff;
  color: #000;
  border: none;
  font-size: 22px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.4);
  transition: background-color 0.2s ease;
  z-index: 1010;
  &:hover {
    background-color: #f2f2f2;
  }
`;
